<div class="questionnaire-field-spacer d-flex flex-column">
    <p-datePicker
            [formControl]="formControl"
            [placeholder]="props.placeholderText | translate"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [showClear]="props.canClear"
            [showTime]="props.showTime"
            [timeOnly]="props.timeOnly"
    >
        <ng-template #inputicon let-clickCallBack="clickCallBack">
            <i *ngIf="props.timeOnly" class="pi pi-clock" (click)="clickCallBack($event)"></i>
            <i  *ngIf="!props.timeOnly" class="pi pi-calendar" (click)="clickCallBack($event)"></i>
        </ng-template>

    </p-datePicker>
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
